import { useQueryClient } from '@tanstack/react-query';
import { Select, t, toast } from '@kanbios/ui';
import { api, unwrap } from '../lib/api';
import { useSession } from '../lib/session';

export type EnvironmentFilter = 'production' | 'non_production' | 'all';
const FILTERS: EnvironmentFilter[] = ['production', 'non_production', 'all'];

/** D73: the global environment filter of the person, sent with every list as `env` (Production by default). */
export function useEnvironmentFilter(): EnvironmentFilter {
  return (useSession().me.preferences.environmentFilter as EnvironmentFilter | undefined) ?? 'production';
}

/**
 * D73 « Production / Hors production / Tout » of the TopBar, beside the
 * scope: production wins (a server hosting one production deployment is
 * production, its other applications with it). Remembered for the person.
 */
export function EnvironmentPicker() {
  const queryClient = useQueryClient();
  const current = useEnvironmentFilter();
  const choose = async (value: string) => {
    try {
      unwrap(await api.maintenance.PUT('/preferences', { body: { environmentFilter: value as EnvironmentFilter } }));
      // Every list carries the filter in its key: they reload with the new preference.
      await queryClient.invalidateQueries({ queryKey: ['me'] });
    } catch {
      toast({ tone: 'neg', title: t('environmentFilter.failed') });
    }
  };
  // A Select, not a Segmented: the lists' own views already have a « Tout ».
  return (
    <Select ariaLabel={t('environmentFilter.label')} size="sm" value={current} onChange={v => { if (v) void choose(v); }}
      options={FILTERS.map(value => ({ value, label: t(`environmentFilter.${value}`) }))} />
  );
}
